<template>
    <div>
        <!-- 筛选 -->
        <my-search
            timeScreen
			buttonScreen
			:order="4"
            :inputArr="inputArr"
            :searchParams="searchParams"
            @searchEvent="searchEvent"
            @addEvent="addEvent"
            @allDel="allDel"
            @allExport="allExport"
            @allImportTemplate="allImportTemplate"
        />

        <!-- 列表 -->
        <my-table
            isSelection
            :loading="loading"
            :tableData="tableData"
            :tableHeader="tableHeader"
            :pageParams="pageParams"
            @click.native="testNative"
            @handleSelectionChange="handleSelectionChange"
        />

        <!-- 分页组件 -->
        <my-pagination :childMsg="pageParams" @callFather="callFather" />

        <!-- 添加、修改组件 -->
        <my-dialog
            :isDialogShow.sync="isDialogShow"
            :operTitle="operTitle"
            :operForm="operForm"
            :operFormArr="operFormArr"
            :selectArrAdd="selectArrAdd"
            :rules="rules"
            :loading="loading"
            @submitForm="submitForm"
            @hook:mounted="doSomeThing"
        />

        <!-- 详情组件 -->
        <my-dialog-detail
            :isDialogDetailShow.sync="isDialogDetailShow"
            :operForm="operForm"
            :operFormArr="operFormArr"
            :closeDialog="closeDialog"
        />
    </div>
</template>

<script>
import { mapState , mapActions} from "vuex"
import _exportMethods from '@/utils/excel'
import mixins from '@/mixins/common'
import {
    menuList,
    addMenu,
    editMenu,
    delMenu,
    allDelMenu,
} from '@/network/system/menu'
export default {
    mixins: [mixins],
    provide() {
        return {
            importType: 'menu',
            initData: this.getInitData,
        }
    },
    watch: {
        tableData: {
            handler(val) {
                // console.log(val);
            },
            immediate: false,
            deep: false,
        },
		roleMenuList:{
			handler(val) {
			   this.getMenuListData();
			},
			immediate: false,
			deep: false,
		}
    },
	computed:{
		...mapState(['roleMenuList'])
	},
    data() {
        return {
            parentList: [], //父级菜单名称列表
            /**
             * 当前头部数据列
             * 不需要响应式的数据可以进行冻结，Vue实例不会对数据再做数据劫持(getter、setter转换),可以提高Vue渲染性能
             * 不可以向当前对象添加、更新、删除属性。如需修改可以将变量的引用替换掉
             */
            tableHeader: Object.freeze([
                {
                    name: '菜单名称',
                    prop: 'name',
                },
                {
                    name: 'url',
                    prop: 'url',
                },
                {
                    name: '创建时间',
                    prop: 'createTime',
                },
                {
                    name: '操作',
                    prop: 'operation',
                    operation: [
                        // { name: "详情", clickFun: this.detailMenu },
                        { name: '编辑', clickFun: this.editMenu, show: true },
                        { name: '删除', clickFun: this.delMenu, show: true },
                    ],
                },
            ]),
            //筛选时文本框所需参数
            inputArr: [
                {
                    name: 'textName',
                    defaultText: '请输入菜单名称',
                },
            ],
            //添加、编辑时下拉框所需参数
            selectArrAdd: [
                {
                    prop: 'parentId',
                    label: '父级菜单名称',
                    getData: 'value',
                    defaultOptions: [],
                },
            ],
            //添加、编辑时文本框所需参数
            operFormArr: [
                {
                    name: 'name',
                    label: '菜单名称',
                    defaultText: '请输入菜单名称',
                },
                {
                    name: 'url',
                    label: 'url',
                    defaultText: '请输入url',
                },
				{
				    name: 'icon',
				    label: '图标',
				    defaultText: '请输入图标',
				},
            ],
            //添加、编辑双向绑定值
            operForm: {
                id: '',
                parentId: '',
                name: '',
                url: '',
				icon: '',
            },
            //搜索参数
            searchParams: {
                timeOptions: '',
                textName: '',
            },
            // rules表单验证
            rules: {
                parentId: [
                    {
                        required: true,
                        message: '请选择父级菜单名称',
                        trigger: 'blur',
                    },
                ],
                name: [
                    {
                        required: true,
                        message: '请输入菜单名称',
                        trigger: 'blur',
                    },
                ],
                url: [
                    {
                        required: true,
                        message: '请输入url',
                        trigger: 'blur',
                    },
                ],
				icon: [
				    {
				        required: true,
				        message: '请输入icon',
				        trigger: 'blur',
				    },
				],
            },
        }
    },
    created() {
        this.getInitData();
		this.getMenuListData();
    },
    methods: {
		...mapActions(['getMenuList']),
        getInitData() {
            let timeOptions = this.searchParams.timeOptions //日期参数
            let params = {
                data: {
                    name: this.searchParams.textName,
                },
                startTime: timeOptions ? timeOptions[0] : '',
                endTime: timeOptions ? timeOptions[1] : '',
                current: this.pageParams.currentPage,
                size: this.pageParams.pageSize,
            }

            menuList(params).then(e => {
                this.loading = false
                let { code, data, msg } = e.data
                if (code == 200) {
                    this.tableData = data.records
                    this.pageParams.total = data.total
                }
            })
        },
		getMenuListData(){
			this.parentList = this.roleMenuList.map((v,i)=>{
				if (v.parentId == 0) {
					if(v.name=="首页"){
						v.id = 0;
					}
				    let obj = {
				        value: v.id,
				        label: v.name,
				    }
					return obj
				}
			})
		
		},
        //添加、编辑
        submitForm(valid) {
            if (valid.valid) {
                //根据类型不同调用不同的操作接口
                let interType = this.operTitle ? addMenu : editMenu
                interType(this.operForm).then(e => {
                    let { code, data, msg } = e.data
                    if (code == 200) {
                        this.isDialogShow = false
                        this.loading = false
                        this.getInitData()
						this.getMenuList(); //更新菜单列表
                        this.$message.success('操作成功')
                    } else {
                        this.$message.error('操作失败')
                    }
                })
            } else {
                return false
            }
        },
        //搜索事件
        searchEvent() {
			this.pageParams.currentPage = 1;
            this.getInitData()
        },
        //添加事件
        addEvent() {
            this.isDialogShow = true
            this.operTitle = true
            this.selectArrAdd[0].defaultOptions = this.parentList
            this.operForm = {} //防止多次添加有上次添加的残留数据
        },
        //详情事件
        detailMenu(item) {
            this.isDialogDetailShow = true
            this.operForm = item
        },
        //编辑事件
        editMenu(item) {
            this.isDialogShow = true
            this.operTitle = false
            this.selectArrAdd[0].defaultOptions = this.parentList;
            this.operForm = {
                id: item.id,
                name: item.name,
                parentId: item.parentId,
                url: item.url,
				icon: item.icon,
            }
			console.log(this.parentList)
			
        },
        //删除事件
        delMenu(item) {
            this.$confirm('删除该条数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                delMenu(item.id).then(e => {
                    let { code, data, msg } = e.data
                    if (code == 200) {
                        this.getInitData()
                        this.$message.success('操作成功')
                    } else {
                        this.$message.error('操作失败')
                    }
                })
            })
        },
        //批量删除
        allDel() {
            let data = this.selectedData
            if (data.length == 0) {
                this.$message.warning('请选择要操作的数据！')
                return
            }
            this.$confirm('删除所选数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let delIds = []
                delIds = data.map(e => e.id)
                allDelMenu({
                    ids: delIds,
                }).then(e => {
                    let { code, data, msg } = e.data
                    if (code == 200) {
                        this.getInitData()
                        this.$message.success('操作成功')
                    } else {
                        this.$message.error('操作失败')
                    }
                })
            })
        },
        //批量导出
        allExport() {
            let timeOptions = this.searchParams.timeOptions //日期参数
            let data = {
                data: {
                    name: this.searchParams.textName,
                },
                startTime: timeOptions ? timeOptions[0] : '',
                endTime: timeOptions ? timeOptions[1] : '',
                current: this.pageParams.currentPage,
                size: this.pageParams.pageSize,
            }
            let exportParams = {
                method: 'post',
                url: '/api/app/sysMenu/export/list',
                data,
            }
            _exportMethods(exportParams)
        },
        //导入模板
        allImportTemplate() {
            let importParams = {
                method: 'get',
                url: '/api/app/sysMenu/export/template',
            }
            _exportMethods(importParams)
        },
        //详情函数式组件关闭弹框
        closeDialog() {
            this.isDialogDetailShow = false
        },
        //在子组件上监听点击事件，如果不加.native的话，Vue会以为是自定义的事件，这样的话必须得在子组件发送一个emit事件触发才可以
        testNative() {
            // console.log("native click");
        },
        //在父组件里监听到子组件的生命周期 @hook:mounted="doSomething"
        doSomeThing() {
            // console.log('父组件监听到 mounted 钩子函数 ...');
        },
    },
}
</script>

<style scoped>
</style>

 
 